import { Box, VStack, HStack } from "@chakra-ui/react";
import { Paragraph02, Paragraph04 } from "~/components/Texts";
import { FiTruck } from "react-icons/fi";
import { AiTwotoneShop } from "react-icons/ai";
import tinycolor from "tinycolor2";

const SHIPPING_METHOD_CUSTOM_SHIPPING = "custom_shipping";

export default function OrderDetailsShipping({ shop, order }) {
  if (order.shipping.method === SHIPPING_METHOD_CUSTOM_SHIPPING)
    return (
      <HStack w="100%" px="4" py="2" align="flex-start" spacing="4">
        <Box
          mt="4"
          p="4"
          borderRadius="full"
          backgroundColor={shop.theme.colors.background.strong}
        >
          <FiTruck
            color={tinycolor
              .mostReadable(
                shop.theme.colors.background.strong,
                [shop.theme.colors.text],
                {
                  includeFallbackColors: true,
                }
              )
              .toHexString()}
          />
        </Box>
        <VStack w="100%" align="flex-start" spacing="1">
          <Paragraph02>
            <b>Envío a domicilio</b>
          </Paragraph02>
          <Paragraph04>Dirección: {order.shipping.address}</Paragraph04>
          <Paragraph04>Provincia: {order.shipping.province}</Paragraph04>
          <Paragraph04>Ciudad: {order.shipping.city}</Paragraph04>
          <Paragraph04>Código Postal: {order.shipping.zipcode}</Paragraph04>
        </VStack>
      </HStack>
    );

  return (
    <HStack w="100%" px="4" py="2" align="flex-start" spacing="4">
      <Box
        mt="4"
        p="4"
        borderRadius="full"
        backgroundColor={shop.theme.colors.background.strong}
      >
        <AiTwotoneShop
          color={tinycolor
            .mostReadable(
              shop.theme.colors.background.strong,
              [shop.theme.colors.text],
              {
                includeFallbackColors: true,
              }
            )
            .toHexString()}
        />
      </Box>
      <VStack w="100%" align="flex-start" spacing="1">
        <Paragraph02>
          <b>Retirás tu compra por el local</b>
        </Paragraph02>
        <Paragraph04>
          {shop.location.address.es ||
            "Contactate con nosotros para retirar tu compra por el local."}
        </Paragraph04>
      </VStack>
    </HStack>
  );
}
